import { Camera, CameraResultType, CameraSource } from '@capacitor/camera'
import { Capacitor } from '@capacitor/core'

/**
 * La foto de evidencia, con la cámara NATIVA cuando corre en la app.
 *
 * En el WebView de Android el <input type="file" capture> es poco fiable: pide
 * el permiso pero muchas veces no abre la cámara y solo ofrece adjuntar. El
 * plugin de Capacitor abre la cámara de verdad y devuelve la foto, que aquí se
 * convierte en un File para subirla igual que las demás.
 *
 * En web (localhost, pruebas) no hay plugin nativo: la tarjeta usa los <input>
 * de archivo de siempre. Por eso esNativo() decide qué mostrar.
 */
export const esNativo = () => Capacitor.isNativePlatform()

/** Toma una foto (cámara) o elige una (galería) y la devuelve como File. */
export async function fotoNativa(desde: 'camara' | 'galeria'): Promise<File | null> {
  const foto = await Camera.getPhoto({
    quality: 60,
    // Un ancho tope para no subir imágenes de 8 MB desde el celular.
    width: 1600,
    correctOrientation: true,
    resultType: CameraResultType.Uri,
    source: desde === 'camara' ? CameraSource.Camera : CameraSource.Photos,
    // La evidencia vive SOLO en Supabase, no en el carrete del técnico: la foto
    // no se guarda en la galería del teléfono. (Por defecto ya es false; se deja
    // explícito porque es un requisito, no un accidente.)
    saveToGallery: false,
  })

  if (!foto?.webPath) return null

  // webPath es una URL local que el WebView sí puede leer; se baja a un blob.
  const respuesta = await fetch(foto.webPath)
  const blob = await respuesta.blob()
  const ext = foto.format || 'jpeg'
  return new File([blob], `evidencia-${Date.now()}.${ext}`, {
    type: blob.type || `image/${ext}`,
  })
}
